export var AssetType;
(function (AssetType) {
    AssetType["Property"] = "PROPERTY";
    AssetType["Vehicle"] = "VEHICLE";
    AssetType["HomeContents"] = "HOME_CONTENTS";
    AssetType["SavingCheckAccount"] = "SAVING_CHECK_ACCOUNT";
    AssetType["Superannuation"] = "SUPERANNUATION";
    AssetType["TermDeposit"] = "TERM_DEPOSIT";
    AssetType["Shares"] = "SHARES";
    AssetType["ManagedFunds"] = "MANAGED_FUNDS";
    AssetType["Gifts"] = "GIFTS";
    AssetType["OtherAsset"] = "OTHER_ASSET";
})(AssetType || (AssetType = {}));
export var AssetPrimaryPurpose;
(function (AssetPrimaryPurpose) {
    AssetPrimaryPurpose["Investment"] = "INVESTMENT";
    AssetPrimaryPurpose["OwnerOccupied"] = "OWNER_OCCUPIED";
})(AssetPrimaryPurpose || (AssetPrimaryPurpose = {}));
//# sourceMappingURL=Assets.js.map